import React, { useState, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import ServiceBasicInformation from './NewServiceForms/ServiceBasicInformation';
import ServiceHeader from './NewServiceForms/ServiceHeader';
import ServiceUpdateUpload from './NewServiceForms/ServiceUpdateUpload';
import ServiceDetails from './NewServiceForms/ServiceDetails';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getService } from 'lib/apiService';
import { updateService } from 'lib/apiService';
import ServiceTag from './NewServiceForms/ServiceTag';

const schema = yup
  .object({
    title: yup.string().required('Энэ талбарыг оруулна уу!'),
    description: yup.string().required('Энэ талбарыг оруулна уу!'),
    tags: yup.array().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const ServiceUpdate = () => {
  let navigage = useNavigate();
  const { blogId } = useParams();

  // images
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  console.log('🚀 ~ ServiceUpdate ~ imageUrls:', imageUrls);
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getService(blogId);
        const newData = response?.data?.data;
        const newTags = newData.tags.map(item => ({
          value: item,
          label: item
        }));
        reset({
          title: newData?.title,
          description: newData?.description,
          tags: newTags
        });
        const buffer = [];
        newData.image.forEach(item => {
          const newFile = {};
          Object.assign(newFile, {
            path: item.public_id,
            preview: item.url
          });
          buffer.push(newFile);
        });
        const updatedData = newData.image.map(item => {
          const obj = {};
          obj.url = item.url;
          obj.name = item.name;
          obj.public_id = item.public_id;
          return obj;
        });
        setImageUrls(updatedData);
        setFiles(buffer);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchData();
  }, [blogId]);

  const imageUploader = async image => {
    setLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setImageUrls(prevUrls => [
      ...prevUrls,
      {
        url: data.secure_url,
        public_id: data.public_id,
        name: data.display_name
      }
    ]);

    setLoading(false);
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      const tags = data.tags.map(item => item.value);
      data.image = imageUrls;
      data.tags = tags;
      updateService(blogId, data)
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай засагдлаа`, {
              theme: 'colored'
            });
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = '';
      }
      reset({ ...submittedValues });
      navigage('/blog/blog-list');
    }
  };

  const handleRemove = async path => {
    setFiles(files.filter(file => file.path !== path));

    const updatedImageUrls = imageUrls.filter(
      image => image.public_id !== path && image.uniqueId !== '200x200.jpg'
    );
    console.log(updatedImageUrls, 'xxxx');
    setImageUrls(updatedImageUrls);
    if (path) {
      axios
        .post(`${process.env.REACT_APP_FILE_URL}/removeimage`, {
          public_id: path,
          fileType: 'image'
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
      console.log('Image deleted successfully from S3.');
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <ServiceHeader />
          </Col>
          <Col lg={8}>
            <ServiceBasicInformation />

            <ServiceUpdateUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <ServiceDetails />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ServiceTag />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default ServiceUpdate;
